(function () {
    'use strict';

	/*
	 ProductsController
	-------------------------------------------------------------------------- */

    angular
        .module('PublicApp.display.products', [])
        .controller('ProductsController', [
            '$scope',
            '__DataStore',
            'appServices',
            '__Utils',
            '$state',
            '$compile',
            'appNotify',
            '$rootScope',
            '$q',
            ProductsController
        ]).controller('ProductsFilterController', [
            '$scope', '$compile', '__Utils', '$rootScope',
            ProductsFilterController
        ]).controller('ProductCompareController', [
            '$scope', '$compile', '__Utils', '$rootScope', '__DataStore', 'appServices',
            ProductCompareController
        ]).controller('SidebarFilterController', [
            '$scope', '$compile', '__Utils', '$rootScope',
            SidebarFilterController
        ]);

	/**
	 * ProductsController for show products
	 * @inject $scope
	 * @inject __DataStore
	 * @inject appServices
	 * @inject __Utils
	 * @inject state
	 * @inject $compile
     * @inject appNotify
	 * 
	 * @return void
	 *-------------------------------------------------------- */

    function ProductsController($scope, __DataStore, appServices,
        __Utils, $state, $compile, appNotify, $rootScope, $q) {

        var scope = this,
            requestURL;

        scope.pageData = {};
        scope.pageStatus = false;
        scope.products = [];
        scope.catID = $state.params.categoryID;

        scope.showPagination = false;

        scope.paginationData = __globals.getAppJSItem('productPaginationData');
        scope.remainingItems = scope.paginationData.remainingItems;
        scope.formattedRemainingItem = scope.paginationData.formattedRemainingItem;
        scope.hasMorePages = scope.paginationData.hasMorePages;
        scope.categoryData = __globals.getAppJSItem('categoryData');
        scope.sortOrderUrl = __globals.getAppJSItem('sortOrderUrl');
        scope.productPrices = __globals.getAppJSItem('productPrices');
        scope.filterPrices = __globals.getAppJSItem('filterPrices');
        scope.currentRoute = __globals.getAppJSItem('currentRoute');
        scope.searchTerm = __globals.getAppJSItem('searchTerm');
        scope.categoryID = __globals.getAppJSItem('categoryID');
        scope.pageType = __globals.getAppJSItem('pageType');
        scope.selectedBrandID = __globals.getAppJSItem('brandID');
        scope.currenCode = __globals.getAppJSItem('currenSymbol');
        scope.filterUrl = __globals.getAppJSItem('filterUrl');
        scope.itemLoadType = parseInt(__globals.getAppJSItem('itemLoadType'));
        // scope.productExistOrNot = false;
        var contentLoaded = false;

        //add product compare function start
        scope.addProductCompare = function (productId) {

            __DataStore.post({
                'apiURL': 'product.compare.add',
                'productId': productId
            }, scope).success(function (responseData) {

                var requestData = responseData.data;
                appServices.processResponse(responseData, null, function (reactionCode) {
                    if (reactionCode == 1) {
                        var countCompareProduct = requestData.countCompareProduct;
                        $scope.$emit('lw.product.compare.count', true);
                    }

                });

            });
        }
        //add product compare function end

        scope.isAddedInWishlist = false;
        /**
          * Add to Wish-list
          *
          * @return void
          *---------------------------------------------------------------- */
        scope.addToWishlist = function (productId) {

            if (!window.__appImmutables.auth_info.authorized) {
                appServices.loginRequiredDialog('login-dialog', null, function (result) {
                });
            } else {
                __DataStore.post({
                    'apiURL': 'product.wishlist.add_process',
                    'productId': productId
                }, scope).success(function (responseData) {
                    var requestData = responseData.data;
                    if (requestData.showLoggedInDialog) {
                        appServices.loginRequiredDialog('login-dialog', null, function (result) { });
                    }

                    appServices.processResponse(responseData, null, function (reactionCode) {

                        if (reactionCode == 1) {
                            $('.lw-remove-wishlist-' + productId).show();
                            $('.lw-add-wishlist-' + productId).hide();

                            scope.isAddedInWishlist = true;
                        }
                    });
                });
            }

        };

        /**
          * Remove from Wish-list
          *
          * @return void
          *---------------------------------------------------------------- */
        scope.removeFromWishlist = function (productId) {

            __DataStore.post({
                'apiURL': 'product.wishlist.remove_process',
                'productId': productId
            }, scope).success(function (responseData) {
                var requestData = responseData.data;
                if (requestData.showLoggedInDialog) {
                    appServices.loginRequiredDialog('login-dialog', null, function (result) { });
                }

                appServices.processResponse(responseData, null, function (reactionCode) {

                    if (reactionCode == 1) {
                        $('.lw-add-wishlist-' + productId).show();
                        $('.lw-remove-wishlist-' + productId).hide();

                        scope.isAddedInWishlist = false;
                    }
                });
            });
        };

        /**
          * Hide Or Show Wish-list Icon
          *
          * @return void
          *---------------------------------------------------------------- */
        scope.getProductWislistData = function (isAddedInWishlist, productId) {

            if (isAddedInWishlist) {

                $('.lw-add-wishlist-' + productId).hide();
                $('.lw-remove-wishlist-' + productId).show();
            } else if (!isAddedInWishlist) {
                $('.lw-remove-wishlist-' + productId).hide();
                $('.lw-add-wishlist-' + productId).show();
            }

        }
        scope.getProductWislistData();

        /**
		 * ProductsController for show products
		 * @inject $scope
		 * @inject __DataStore
		 * @inject appServices
		 * @inject __Utils
		 * @inject state
		 * @inject $stateParams
		 * 
		 * @return void
		 *-------------------------------------------------------- */
        scope.showPagination = function (requestURL) {

            scope.isRequestInProcessing = true;

            __DataStore.fetch(requestURL, { fresh: true })
                .success(function (responseData) {

                    appServices.processResponse(responseData, null, function (reactionCode) {

                        var requestData = responseData.data;
                        scope.isRequestInProcessing = false;
                        scope.productExistOrNot = requestData.productExistOrNot;
                        scope.endOfList = requestData.paginationData.currentPage == requestData.paginationData.lastPage;
                        scope.remainingItems = requestData.paginationData.remainingItems;
                        scope.formattedRemainingItem = requestData.paginationData.formattedRemainingItem;
                        scope.hasMorePages = requestData.paginationData.hasMorePages;
                        scope.paginationData = requestData.paginationData;
                        scope.pageType = requestData.pageType;

                        //show or hide wishlist icon
                        _.defer(function () {
                            _.forEach(requestData.products, function (value, key) {

                                if (value.isAddedInWishlist) {

                                    $('.lw-add-wishlist-' + value.id).hide();
                                    $('.lw-remove-wishlist-' + value.id).show();
                                } else if (!value.isAddedInWishlist) {

                                    $('.lw-remove-wishlist-' + value.id).hide();
                                    $('.lw-add-wishlist-' + value.id).show();
                                }
                            });
                        });


                        if (scope.itemLoadType === 3) { // pagination

                            $masonryInstance.masonry('remove', $('.lw-product-box')).masonry('layout');
                            $(window).scrollTop(0);

                            if (requestData.paginationData.currentPage > 1) {
                                $('.lw-nondescript-content').remove();
                            }
                        }


                        if (!_.isEmpty(requestData.products)) {

                            _.forEach(requestData.products, function (product, key) {

                                var $items = $compile(__Utils.template('#productListItemTemplate', product))($scope);

                                // append items to grid                          
                                $masonryInstance.append($items);

                                // add and lay out newly appended items
                                $masonryInstance.masonry('appended', $items);
                            });

                            $('.lw-product-list-popover').popover({
                                html: true,
                                content: function () {
                                    return __globals.getJSString('addon_option_affect_string')
                                }
                            });

                            $('.product-item-thumb-image').Lazy({
                                afterLoad: function (element) {
                                    // called after an element was successfully handled
                                    $masonryInstance.masonry('layout');
                                    $('.lw-ribbon-wrapper-green').removeClass('lw-zero-opacity');
                                },
                                onFinishedAll: function () {
                                    // called once all elements was handled
                                    scope.isRequestInProcessing = false;
                                }
                            });
                            // create pagination links
                            if (scope.itemLoadType === 3) {

                                var $paginationLinksElement = $(".lw-pagination-container > ul");

                                if ($paginationLinksElement) {
                                    $paginationLinksElement.html(requestData.paginationData.paginationLinks);
                                }
                            }
                        }
                    });
                });

            contentLoaded = true;
        };


		/**
          * scroll pagination
          *
          * @return void
          *---------------------------------------------------------------- */

        scope.isRequestInProcessing = false;

        scope.scrollPagination = function () {

            $(window).scroll(function () {
                if ((scope.paginationData.currentPage < scope.paginationData.lastPage)
                    && ($(window).scrollTop() + $(window).height()) > ($(document).height() - 750)
                    && scope.isRequestInProcessing == false) {
                    scope.paginationData.currentPage = scope.paginationData.currentPage + 1;
                    scope.productExistOrNot = true;

                    var requestURL = scope.sortOrderUrl + 'page=' + scope.paginationData.currentPage;

                    scope.showPagination(requestURL);
                    scope.isRequestInProcessing = true;
                }
            });

        };

        scope.loadProductsOnBtnClick = function () {

            if (scope.paginationData.currentPage < scope.paginationData.lastPage) {

                scope.paginationData.currentPage = scope.paginationData.currentPage + 1;

                var requestURL = scope.sortOrderUrl + 'page=' + scope.paginationData.currentPage;

                scope.showPagination(requestURL);
            }

        };

        if (scope.itemLoadType === 1) { // scroll

            scope.scrollPagination();

        } else if (scope.itemLoadType === 3) {  // pagination

            // scope.loadProductsOnBtnClick();

            if (contentLoaded == false) {

                var $initPaginationLinksElement = $(".lw-pagination-container");

                if ($initPaginationLinksElement) {
                    $initPaginationLinksElement.html(scope.paginationData.paginationLinks);
                }
            }

            $(".lw-pagination-container").on('click', 'a', function (event) {

                event.preventDefault();

                var $this = $(this),
                    url = $this.attr('href');
                var requestURL = scope.sortOrderUrl + 'page=' + url.split('page=')[1];
                scope.showPagination(requestURL);

            });
        }


        /**
          * Show details dialog
          *
          * @param object eventObj
          * @return void
          *---------------------------------------------------------------- */
        scope.dialogStatus = false;
        scope.showDetailsDialog = function (eventObj, pID, pageType) {

            appServices.showDialog({
                categoryID: scope.categoryID,
                productID: pID,
                pageType: pageType,
                dialogStatus: scope.dialogStatus
            },
                {
                    templateUrl: __globals.getTemplateURL(
                        'product.details-dialog'
                    ),
                    controller: "ProductDetailsDialogController as productDetailsDialogCtrl",
                    resolve: {

                        GetProductDetails: function () {

                            //create a differed object          
                            var defferedObject = $q.defer();

                            __DataStore.fetch({
                                'apiURL': 'product.quick.view.details.support_data',
                                'productID': pID,
                                'categoryID?': scope.categoryID
                            }, { 'fresh': true }).success(function (responseData) {

                                appServices.processResponse(responseData, null, function (reactionCode) {

                                    //this method calls when the require        
                                    //work has completed successfully        
                                    //and results are returned to client        
                                    defferedObject.resolve(responseData);

                                });

                            });

                            //return promise to caller          
                            return defferedObject.promise;
                        }
                    }
                },
                function (promiseObj) {

                });


        };

        /**
         * filter dialog product
         *
         * @param brandID
         * @param resultedProudctIds
         *
         * @return void
         *---------------------------------------------------------------- */
        scope.filterDailogProduct = function (filterUrl) {

            scope.brandPageType = false;

            __DataStore.fetch(filterUrl, { fresh: true })
                .success(function (responseData) {

                    scope.brandsData = responseData.data.productRelatedBrand;
                    scope.selectedIDs = scope.brandsData;

                    appServices.showDialog(scope,
                        {
                            templateUrl: __globals.getTemplateURL(
                                'product.filter-dialog'
                            )
                        },
                        function (promiseObj) {

                        });

                });
        };

		/**
        * display all active products list
        *
        * @return void
        *---------------------------------------------------------------- */

        scope.getProductDetails = function () {

            // send http request to server
            __DataStore.fetch({
                'apiURL': 'product.quick.view.details.support_data',
                'productID': scope.productID,
                'categoryID?': scope.categoryID
            }).success(function (responseData) {

                appServices.processResponse(responseData, null, function (reactionCode) {

                    var requestData = responseData.data.details;

                    scope.productDetails = requestData;

                    scope.productData = {
                        'name': scope.productDetails.name,
                        'quantity': 1,
                        'isCartExist': false
                    };

                    scope = __Form.updateModel(scope, scope.productData);

                    scope.productDetails.basePriceWithAddonPrice = requestData.newTotalPrice;

                    scope.newTotalPriceCount = requestData.newTotalPriceCount;

                    scope.productDetails.selectedOptions = requestData.getSelectedOptions;

                    if (scope.productDetails) {
                        scope.productData.name = requestData.name;
                    }

                    if (!_.isEmpty(scope.productDetails.getSelectedOptions)) {
                        scope.optionLength = true;
                    }

                    scope.productDetails.priceDetails = {
                        'option': requestData.getSelectedOptions,
                        'total': requestData.getPrice.total,
                        'base_price': requestData.getPrice.base_price
                    };

                    // product quantity
                    if (requestData.qtyCart > 0) {

                        scope.productData.quantity = requestData.qtyCart;
                        scope.checkNumber = true;

                    } else {
                        scope.productData.quantity = 1;
                    }

                    scope.btnQuantity = requestData.qtyCart;
                    scope.productData.isCartExist = requestData.isCartExist;

                    scope.pageStatus = true;

                });
            });
        };
        // scope.getProductDetails();

		/**
		* Add to cart with options
		*
		* @return void
		*---------------------------------------------------------------- */
        scope.addToCartWithOptions = function (event, productID) {

            $(event.currentTarget).popover({
                html: false,
                placement: 'auto',
                animation: 'fadeIn',
                content: function () {
                    return $compile(__Utils.template('#lwProductOptionsTemplate', 'item'))($scope);
                }
            });
        };

		/**
		  * Add product as a cart item
		  *
		  * @return void
		  *---------------------------------------------------------------- */
        scope.addToCart = function (event, productID, productName) {

            event.preventDefault();

            var currentElement = $(event.currentTarget);

            scope.productCartData = {
                'name': unescape(productName).split('+').join(' '),
                'quantity': _.add(currentElement.data('quantity'), 1),
                'isCartExist': false
            };

            __DataStore.post({
                apiURL: 'cart.add.item',
                productID: productID
            }, scope.productCartData).success(function (responseData) {

                scope.cartAction = true;

                var requestData = responseData.data;

                appServices.processResponse(
                    responseData,
                    null,
                    function () {

                        scope.data = {
                            'cart_string': responseData.data.cartItems,
                            'status': true,
                            'showNotification': true
                        };

                        currentElement.data('quantity', responseData.data.qtyCart);

                        // scope.updateCartRow(productID, true);

                        $scope.$emit('lw.update.cart.string', scope.data);
                    }
                );

            });
        };

        // when the cart item remove from to cart
        $rootScope.$on('lw.cart_update', function (events, updatedData) {

            if (updatedData.action == 1 || updatedData.action == 2) {

                var $lwElement = $('.lw-product-' + updatedData.pid),
                    $lwProduct = $($lwElement[0]);

                if ($lwProduct) {
                    $lwProduct.data('quantity', updatedData.qty);
                }

            } else if (updatedData.action == 3) {

                var $allProducts = $('.lw-products-container');

                $allProducts.each(function (index) {

                    $('.lw-quick-cart-btn').each(function (i) {

                        var $everyItem = $(this),
                            itemPid = $everyItem.data('pid');
                        $everyItem.data('quantity', 0);
                    });

                });
            }

        });

        scope.unescapeProductName = function (productName, from) {
            if (from == 1) {
                return unescape(productName).split('+').join(' ');
            } else if (from == 2) {
                return unescape(productName);
            }
        };

    };

    /**
     * ProductCompareController for show products
     *
     * @inject $scope
     * @inject $compile
     * @inject __Utils
     * @inject $rootScope
     * 
     * @return void
     *-------------------------------------------------------- */

    function ProductCompareController($scope, $compile, __Utils, $rootScope, __DataStore, appServices) {
        var scope = this;

        scope.getProductCompareData = function () {
            __DataStore.fetch('product.compare.read.data', { fresh: true })
                .success(function (responseData) {

                    var requestData = responseData.data;
                    appServices.processResponse(responseData, null, function (reactionCode) {
                        scope.productCompareData = requestData.productCompareData;
                        scope.specificationCollection = requestData.specificationCollection;

                    });
                });
        }
        scope.getProductCompareData();

        //check compare data are blank or not.
        scope.getPaire = function (specData, specId) {
            return _.filter(specData, function (value, key) {
                if (value.specifications__id === specId) {
                    return value.value;
                }
            });
        };

        //remove product compare function start
        scope.removeProduct = function (productId) {

            __DataStore.post({
                'apiURL': 'product.compare.remove',
                'productId': productId
            }, scope).success(function (responseData) {

                appServices.processResponse(responseData, null, function () {

                    if (responseData.reaction == 1) {
                        scope.getProductCompareData();

                        $scope.$emit('lw.product.compare.count', true);
                    }

                });

            });

        };
        //remove product compare function end
    };

    /**
	 * ProductsFilterController for show products
	 *
	 * @inject $scope
	 * @inject $compile
	 * @inject __Utils
	 * @inject $rootScope
	 * 
	 * @return void
	 *-------------------------------------------------------- */

    function ProductsFilterController($scope, $compile, __Utils, $rootScope) {

        var scope = this;

        scope.dialogData = $scope.ngDialogData;
        scope.brandsData = scope.dialogData.brandsData;
        scope.pageType = $scope.ngDialogData.pageType;
        scope.currentUrl = scope.dialogData.currentRoute;
        scope.productPrices = scope.dialogData.productPrices;
        scope.filterPrices = scope.dialogData.filterPrices;
        scope.selectedBrandID = scope.dialogData.selectedBrandID
        scope.searchTerm = scope.dialogData.searchTerm;
        scope.brandPageType = scope.dialogData.brandPageType;
        scope.selectedIDs = scope.dialogData.selectedIDs;
        scope.currenCode = scope.dialogData.currenCode;

        scope.brandExistStatus = false;
        if (!_.isEmpty(scope.brandsData)) {
            scope.brandExistStatus = true;
        };

        scope.selectedRows = [];
        scope.noSelectedItems = false;
        scope.allSelectedItems = false;
        scope.priceStatus = false;

        // select brand
        angular.forEach(scope.selectedBrandID, function (value, index) {

            if (!_.isEmpty(scope.selectedIDs)) {

                angular.forEach(scope.selectedIDs, function (brand, bIndex) {

                    if (scope.selectedIDs[bIndex]['brandID'] == value) {

                        scope.selectedIDs[bIndex]['isSelected'] = true;
                    }

                });

            }


        });

        $scope.$on('ngDialog.opened', function (e, $dialog) {

            scope.priceStatus = false;
            // check product price
            if (scope.productPrices.min_price != scope.productPrices.max_price) {

                if (scope.pageType == 'brand') {
                    $('#manageFilterTabs a').trigger('click');
                }

                scope.priceStatus = true;

                scope.sliderBar = {
                    minValue: scope.filterPrices.min_price,
                    maxValue: scope.filterPrices.max_price,
                    minLimit: 0,
                    options: {
                        minRange: 1,
                        maxRange: scope.filterPrices.max_price,
                        pushRange: true,
                        floor: Math.floor(scope.productPrices.min_price),
                        ceil: Math.floor(scope.productPrices.max_price),
                        onChange: function (id, newValue, highValue, pointerType) {
                            var minValue = newValue;

                            var maxValue = highValue;

                            $('.lw-min-price').prop('value', minValue).prop('name', 'min_price');
                            $('.lw-max-price').prop('value', maxValue).prop('name', 'max_price');

                        },
                        translate: function (value, sliderId, label) {
                            switch (label) {
                                case 'model':
                                    return '<b>Min price:</b>' + scope.currenCode + value;
                                case 'high':
                                    return '<b>Max price:</b>' + scope.currenCode + Math.floor(value);
                                default:
                                    return scope.currenCode + value
                            }
                        }
                    }
                };

                scope.changeFilterPrice = function (minValue, maxValue) {
                    $('.lw-min-price').prop('value', minValue).prop('name', 'min_price');
                    $('.lw-max-price').prop('value', maxValue).prop('name', 'max_price');
                };
            }
        });

        scope.showPriceFilter = false;

        //sidebar range filter
        scope.loadView = function () {

            setTimeout(function () {

                $scope.$broadcast('rzSliderForceRender');
                scope.showPriceFilter = true;
            }, 1500);
        }
        scope.loadView();

        /**
         * Close dialog
         *
         * @return void
         *---------------------------------------------------------------- */
        scope.close = function () {
            $scope.closeThisDialog();
        }

        /**
	  	  * Clear Filter
	  	  *
	  	  * @return void
	  	  *---------------------------------------------------------------- */
        scope.clearFilter = function () {

            $scope.closeThisDialog({ close: true });

        }

    };

    /**
     * Side bar filter controller
     *
     * @inject $scope
     * @inject $compile
     * @inject __Utils
     * @inject $rootScope
     * 
     * @return void
     *-------------------------------------------------------- */

    function SidebarFilterController($scope, $compile, __Utils, $rootScope) {

        var scope = this;
        scope.currentFilterUrl = '';
        scope.showClearButton = false;

        /**
         * Initialize Filter Data
         ***********************************************/
        scope.filterInitData = function (filterMinPrice, filterMaxPrice, productMinPrice, productMaxPrice, currenSymbol, currentFilterUrl) {
            scope.currentFilterUrl = unescape(currentFilterUrl).split('+').join(' ');
            scope.sliderBar = {
                minValue: filterMinPrice,
                maxValue: filterMaxPrice,
                options: {
                    floor: Math.floor(productMinPrice),
                    ceil: Math.ceil(productMaxPrice),
                    onChange: function (id, newValue, highValue, pointerType) {
                        scope.sliderBar.min_price = newValue;
                        scope.sliderBar.max_price = highValue;
                    },
                    translate: function (value, sliderId, label) {
                        switch (label) {
                            case 'model':
                                return currenSymbol + value;
                            case 'high':
                                return currenSymbol + Math.floor(value);
                            default:
                                return currenSymbol + value
                        }
                    },
                    onEnd: function (sliderId, minValue, maxValue, pointerType) {
                        scope.filterByPrice(scope.currentFilterUrl, minValue, maxValue);
                    }
                }
            };

            var currentPageUrl = window.location.href;
            if (currentPageUrl.indexOf('?') > -1) {
                scope.showClearButton = true;
            }

            //sidebar range filter
            $(window).resize(function () {
                setTimeout(function () {
                    $scope.$broadcast('reCalcViewDimensions');
                }, 200);
            });
        }

        // Change filter price
        scope.changeFilterPrice = function (minPrice, maxPrice, currentFilterUrl) {
            scope.sliderBar.minValue = minPrice;
            scope.sliderBar.maxValue = maxPrice;
            scope.filterByPrice(decodeURIComponent(currentFilterUrl).split('+').join(' '), minPrice, maxPrice);
        }

        // Filter url by price
        scope.filterByPrice = function (currentUrl, minPrice, maxPrice) {
            var urlParams = new URLSearchParams(currentUrl),
                minPriceString = urlParams.get('min_price'),
                maxPriceString = urlParams.get('max_price');

            currentUrl = currentUrl.replace('&min_price=' + minPriceString, '&min_price=' + minPrice);
            currentUrl = currentUrl.replace('&max_price=' + maxPriceString, '&max_price=' + maxPrice);
            __globals.redirectBrowser(currentUrl);
        }

        // Clear Price Filter
        scope.clearPriceFilter = function (currentUrl, minPrice, maxPrice) {
            currentUrl = unescape(currentUrl).split('+').join(' ');
            var priceFilterUrl = currentUrl.replace('&min_price=' + minPrice + '&max_price=' + maxPrice, '');
            __globals.redirectBrowser(priceFilterUrl);
        }

        // Prepare Current Url
        scope.prepareCurrentUrl = function (currentUrl, brandId, specificationId, ratingId, status, catId) {
            currentUrl = unescape(currentUrl).split('+').join(' ');
            var urlParams = new URLSearchParams(currentUrl),
                brandsIdString = urlParams.get('brandsIds'),
                specsIdString = urlParams.get('specsIds'),
                ratingIdString = urlParams.get('rating'),
                availabilityIdString = urlParams.get('availability'),
                categoryIdString = urlParams.get('categories'),
                specsIds = [],
                brandsIds = [],
                catsIds = [];

            if (!_.isEmpty(brandsIdString)) {
                brandsIds = brandsIdString.split('|');
            }
            if (!_.isEmpty(specsIdString)) {
                specsIds = specsIdString.split('|');
            }
            if (!_.isEmpty(categoryIdString)) {
                catsIds = categoryIdString.split('|');
            }

            if (!_.isEmpty(brandId)) {

                if (_.includes(brandsIds, brandId)) {
                    _.remove(brandsIds, function (item) {
                        return brandId == item;
                    });
                } else {
                    brandsIds.push(brandId);
                }

                brandsIds = brandsIds.join("|");
                currentUrl = currentUrl.replace('brandsIds=' + brandsIdString, 'brandsIds=' + brandsIds);
            }

            if (!_.isEmpty(specificationId)) {

                if (_.includes(specsIds, specificationId)) {
                    _.remove(specsIds, function (item) {
                        return specificationId == item;
                    });
                } else {
                    specsIds.push(specificationId);
                }

                specsIds = specsIds.join("|");
                currentUrl = currentUrl.replace('specsIds=' + specsIdString, 'specsIds=' + specsIds);
            }

            if (!_.isEmpty(catId)) {

                if (_.includes(catsIds, catId)) {
                    _.remove(catsIds, function (item) {
                        return catId == item;
                    });
                } else {
                    catsIds.push(catId);
                }

                catsIds = catsIds.join("|");
                currentUrl = currentUrl.replace('categories=' + categoryIdString, 'categories=' + catsIds);
            }

            if (!_.isEmpty(ratingId)) {
                if (ratingId == 'clear') {
                    currentUrl = currentUrl.replace('rating=' + ratingIdString, 'rating=');
                } else {
                    currentUrl = currentUrl.replace('rating=' + ratingIdString, 'rating=' + ratingId);
                }
            }

            if (!_.isEmpty(status)) {
                if (status == 'clear') {
                    currentUrl = currentUrl.replace('availability=' + availabilityIdString, 'availability=');
                } else {
                    currentUrl = currentUrl.replace('availability=' + availabilityIdString, 'availability=' + status);
                }
            }

            __globals.redirectBrowser(currentUrl);
        }
    }

})();